import React from "react";
import Project from "./projetEtp";

export function ProjectCanceld() {
  return <Project status="Annulé" />;
}